import { MouseEvent, useState } from "react";
import { GetLoggedInUserQuery } from "types/graphql-schema";

import ConnectCalendarModal from "@apps/connect-calendar-modal/connect-calendar-modal";
import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";

const SidebarOnboarding = ({
  currentUser,
}: {
  currentUser: NonNullable<GetLoggedInUserQuery["me"]>;
}) => {
  const [open, setOpen] = useState(false);
  const hasCalendarCredentials = currentUser.syncCredentials?.edges.find(
    (edge) => edge?.node?.hasValidCalendarCredentials,
  );
  if (
    hasCalendarCredentials ||
    currentUser.status === "demo" ||
    currentUser.calendarIsSyncingForFirstTime
  ) {
    return null;
  }
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    setOpen(true);
  };
  return (
    <>
      <ConnectCalendarModal open={open} onClose={setOpen} />
      <div className="flex flex-col justify-center items-center text-sm">
        <div className="font-medium text-center">
          Link Your Calendar to Stay in Flow
        </div>
        <div className="text-gray-500 text-center mt-1 mb-3">
          Instantly view your meetings without jumping between tools.
        </div>
        <Button
          onClick={handleClick}
          theme={buttonTheme.lightBlue}
          text="Connect your calendar"
        />
      </div>
    </>
  );
};
export default SidebarOnboarding;
